"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmBreadcrumb = exports.SmBreadcrumbItem = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Hyperlink_1 = require("../Hyperlink");
const Icon_1 = require("../Icon");
const SmBreadcrumbItem = (_a) => {
    var { text, href } = _a, props = __rest(_a, ["text", "href"]);
    return (react_1.default.createElement("li", { className: "c-breadcrumb__list__item" },
        react_1.default.createElement(Hyperlink_1.SmHyperlink, Object.assign({}, props, { className: "c-breadcrumb__list__item__link", text: text, isRaw: true, href: href, target: "_self" }))));
};
exports.SmBreadcrumbItem = SmBreadcrumbItem;
const SmBreadcrumb = (_a) => {
    var { items, className } = _a, props = __rest(_a, ["items", "className"]);
    const crumbClassName = (0, classnames_1.default)('c-breadcrumb', className);
    const length = items ? items.length : 0;
    return items && length > 0 ? (react_1.default.createElement("nav", Object.assign({}, props, { className: crumbClassName, "aria-label": "Breadcrumb" }),
        react_1.default.createElement("ol", { className: "c-breadcrumb__list" },
            react_1.default.createElement("li", { className: "c-breadcrumb__list__item" },
                react_1.default.createElement(Hyperlink_1.SmHyperlink, { className: "c-breadcrumb__list__item__link -home", icon: react_1.default.createElement(Icon_1.SmIcon, { name: "home", type: "round" }), isRaw: true, href: window.location.origin, title: "P\u00E1gina inicial", target: "_self" })),
            items.map((item, index) => {
                var _a;
                return (react_1.default.createElement(exports.SmBreadcrumbItem, { key: `${new Date().getTime()}-${item.text}-${(_a = item.href) === null || _a === void 0 ? void 0 : _a.toString()}}`, text: item.text, href: index === length - 1 ? undefined : item.href, "aria-current": index === length - 1 && 'page' }));
            })))) : null;
};
exports.SmBreadcrumb = SmBreadcrumb;
//# sourceMappingURL=index.js.map